module.exports = __webpack_public_path__ + "static/media/flag.b05c807b.jpg";